<template>
  <div style="margin-top: 30px; padding:11px;">
    <div style="display: flex; justify-content: space-between;">
      <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
        Firma Yetkili Ekle
      </button>

      <button type="button" class="btn btn-success" @click="exportOfficialsToExcel">
        Excel'e Aktar
      </button>
    </div>

    <!-- ARAMA KUTUSU -->
    <div class="my-3">
      <input
          type="text"
          class="form-control"
          v-model="searchQuery"
          placeholder="Adı Soyadı'na göre ara..."
      >
    </div>

    <div class="table-responsive">
      <table class="table align-middle">
        <thead>
        <tr>
          <td><b> Firma </b></td>
          <td><b> Adı Soyadı </b></td>
          <td><b> Email </b></td>
          <td><b> Telefon </b></td>
          <td><b> Görev Ünvan </b></td>
          <td><b> İşlemler </b></td>
        </tr>
        </thead>

        <!-- GÜNCELLENMİŞ TBODY BÖLÜMÜ -->
        <tbody>
        <!-- Mevcut veri listeleme döngüsü -->
        <tr v-for="val in filteredOfficials" v-bind:key="val.id">
          <td><b>{{val.companyName}}</b></td>
          <td>{{val.nameSurname}}</td>
          <td>{{val.email}}</td>
          <td>{{val.phoneNumber}}</td>
          <td>{{val.jobTitle}}</td>
          <td>
            <button type="button" class="btn btn-danger"
                    data-bs-toggle="modal"
                    data-bs-target="#companyDeleteModal"
                    @click="setDeleteId(val.id)">Sil</button>
             
            <button type="button" class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="editCompanyOfficials(val.id)">Düzenle</button>
            <div class="modal fade" id="companyDeleteModal" tabindex="-1" aria-labelledby="companyDeleteModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="companyDeleteModalLabel">Silme Onayı</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <p>Bu öğeyi silmek istediğinizden emin misiniz?</p>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">İptal</button>
                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="companyOfficialsDelete(deleteId)">Evet, Sil</button>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>

        <!-- YENİ EKLENEN "BULUNAMADI" MESAJI SATIRI -->
        <tr v-if="filteredOfficials.length === 0">
          <td colspan="6" class="text-center text-muted">
            Bu isimde firma yetkili bulunmamaktadır.
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal ve diğer kısımlar aynı kalıyor -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content" :class="{ 'wide-modal': step === 4 }"  style=" min-height: 500px; width: 750px; display: flex; flex-direction: column;">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel"> {{ isEditing ? 'Firma Yetkili Düzenle' : 'Firma Yetkili Ekle' }}</h5>
            <button type="button" style="background-color: #2419d2;" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body" style="overflow-y: auto;">
            <div class="mb-3">
              <label for="exampleFormContFirmaInput1" class="form-label">Adı Soyadı</label>
              <input type="text" class="form-control" v-model="itemsCompanyOfficial.nameSurname" placeholder="Adı Soyadı">
            </div>
            <hr>

            <div class="mb-3">
              <label for="exampleFormContFirmaInput2" class="form-label">Email</label>
              <input type="text" class="form-control" v-model="itemsCompanyOfficial.email" placeholder="Email">
            </div>
            <hr>
            <div class="mb-3">
              <label for="exampleFormContFirmaInput3" class="form-label">Telefon Numarası</label>
              <input type="text" class="form-control" v-model="itemsCompanyOfficial.phoneNumber" placeholder="Telefon Numarası">
            </div>
            <hr>


            <div class="mb-3">
              <label for="exampleFormContFirmaInput4" class="form-label d-flex justify-content-between align-items-center">
                <span>Firma Adı</span>
                <router-link to="/companies" class="ms-3 text-decoration-underline">Firma Ekle</router-link>
              </label>
              <select class="form-select" v-model="itemsCompanyOfficial.companiesId">
                <option v-for="(companies, index) in companiesData" :key="index" :value="companies.id">
                  {{ companies.companyName }}
                </option>
              </select>
            </div>

            <hr>
            <div class="mb-3">
              <label for="exampleFormContFirmaInput5" class="form-label">Görev&Ünvan</label>
              <input type="text" class="form-control" v-model="itemsCompanyOfficial.jobTitle" placeholder="Görev&Ünvan">
            </div>

          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Vazgeç</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="isEditing ? updateCompanyOfficial() : createCompanyOfficial()">
              {{ isEditing ? 'Güncelle' : 'Kaydet' }}
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
// @ts-nocheck

import apiClient from "@/axios";
import * as XLSX from "xlsx";

export default {
  name: "CompanyOfficials",
  data() {
    return {
      companyOfficialsData: [],
      deleteId: null,
      isEditing: false,
      itemsCompanyOfficial: {},
      companiesData: {},
      searchQuery: '',
    };
  },
  computed: {
    filteredOfficials() {
      if (!Array.isArray(this.companyOfficialsData)) {
        return [];
      }

      if (!this.searchQuery) {
        return this.companyOfficialsData;
      }

      const searchTerm = this.searchQuery.toLowerCase();

      return this.companyOfficialsData.filter(official =>
          official.nameSurname.toLowerCase().includes(searchTerm)
      );
    }
  },
  created() {
    this.getCompanyOfficialsData();
    this.getCompaniesData();
  },
  methods: {
    exportOfficialsToExcel() {
      const visibleFields = {
        "Firma": true,
        "Adı Soyadı": true,
        "Email": true,
        "Telefon": true,
        "Görev Ünvan": true,
      };
      const data = this.companyOfficialsData.map(official => {
        let row = {};
        if (visibleFields["Firma"]) row["Firma"] = official.companyName;
        if (visibleFields["Adı Soyadı"]) row["Adı Soyadı"] = official.nameSurname;
        if (visibleFields["Email"]) row["Email"] = official.email;
        if (visibleFields["Telefon"]) row["Telefon"] = official.phoneNumber;
        if (visibleFields["Görev Ünvan"]) row["Görev Ünvan"] = official.jobTitle;
        return row;
      });
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Firma Yetkilileri");
      XLSX.writeFile(workbook, "Firma_Yetkilileri.xlsx");
    },
    getCompaniesData() {
      apiClient.get("companies/all").then(res => {
        this.companiesData = res.data;
      });
    },
    updateCompanyOfficial() {
      const payload = {
        id: this.itemsCompanyOfficial.id,
        nameSurname: this.itemsCompanyOfficial.nameSurname,
        email: this.itemsCompanyOfficial.email,
        phoneNumber: this.itemsCompanyOfficial.phoneNumber,
        jobTitle: this.itemsCompanyOfficial.jobTitle,
        companiesId: { id: this.itemsCompanyOfficial.companiesId, },
      };
      apiClient
          .put(`/companyOfficials/${this.itemsCompanyOfficial.id}`, payload)
          .then(() => {
            this.getCompanyOfficialsData();
            this.isEditing = false;
          })
    },
    createCompanyOfficial() {
      const payload = [{
        ...this.itemsCompanyOfficial,
        companiesId: { id: this.itemsCompanyOfficial.companiesId },
      }];
      apiClient.post("/companyOfficials", payload).then(res => {
        this.itemsCompanyOfficial = {
          nameSurname: "",
          email: "",
          phoneNumber: "",
          jobTitle: "",
          companiesId: null,
        };
        this.getCompanyOfficialsData();
      })
    },
    editCompanyOfficials(id) {
      apiClient.get(`/companyOfficials/${id}`).then(res => {
        this.itemsCompanyOfficial = res.data;
        this.itemsCompanyOfficial.companiesId = res.data.companyId;
        this.isEditing = true;
      })
    },
    getCompanyOfficialsData() {
      apiClient.get("/companyOfficials").then(res => {
        this.companyOfficialsData = res.data;
      });
    },
    setDeleteId(id) {
      this.deleteId = id;
    },
    companyOfficialsDelete(id) {
      apiClient.delete(`/companyOfficials/${id}`)
          .then(() => {
            this.getCompanyOfficialsData();
          })
          .catch(error => {
            console.error("Silme işlemi sırasında hata oluştu:", error);
          });
    }
  },
}
</script>

<style scoped>

</style>
